import { Checkbox, Input, Slider } from "@aqar-app/react-ui";
import { useEffect, useMemo, useRef, useState } from "react";
import { useRouter } from "next/router";
import { AppLink } from "../../new-resolver/app.ink";
import css from "./.module.scss";
import { generateUrl, usePath } from "@/contexts/path/path";

function RadioControl({
  onChange,
  operation,
  label,
  options,
  name,
  value,
} = {}) {
  const { page, listing, ...pathData } = usePath();
  // eslint-disable-next-line prefer-const
  const url = useMemo(() => generateUrl(pathData)?.split("?")[0], []);

  function getClass(opt) {
    try {
      if (typeof opt.value === "object")
        if (
          JSON.stringify(value)?.replace(/"/g, "") ===
          JSON.stringify(opt.value)?.replace(/"/g, "")
        )
          return css.active;
        else return undefined;

      if (`${value}` === `${opt.value}`) return css.active;
      return undefined;
    } catch {
      return undefined;
    }
  }
  if (!options) return null;
  return (
    <div className={`${css.control} ${css.radio}`}>
      <p>{label?.ar}</p>
      <div className={css.horizontalList}>
        {options
          .filter((opt) => opt.value !== undefined)
          .map((opt) => (
            <AppLink
              key={name + opt.path || opt.value}
              className={getClass(opt)}
              onClick={() => {
                if (opt.value === undefined || value === opt.value)
                  return onChange?.(name, undefined);

                if (typeof opt.value === "object")
                  return onChange?.(name, opt.value);
                return onChange?.(
                  name,
                  {
                    [operation]: opt.value,
                  },
                  opt.path,
                );
              }}
              path={url + (opt.path || "")}
            >
              {opt?.label?.ar}
            </AppLink>
          ))}
      </div>
    </div>
  );
}

function CheckboxControl({
  onChange,
  operation,
  label,
  name,
  value,
  path,
  ...props
} = {}) {
  const { listing, page, ...pathData } = usePath();

  const url = useMemo(() => generateUrl(pathData)?.split("?")[0], []);
  const checkbox = useRef(null);
  return (
    <AppLink
      onClick={(e) => {
        checkbox.current.checked = !checkbox.current.checked;
        if (!checkbox.current?.checked) return onChange?.(name);
        return onChange?.(name, {
          [operation]: 1,
        });
      }}
      path={url + (path || "")}
    >
      <Checkbox ref={checkbox} checked={!!value} {...props} switch={false}>
        {label.ar}
      </Checkbox>
    </AppLink>
  );
}

function SelectControl(props) {
  return <RadioControl {...props} />;
}

function SliderControl({
  onChange,
  operation,
  label,
  name,
  value,
  type,
  span,
  ...props
} = {}) {
  return (
    <div
      style={{
        gridColumn: `1 / span ${span || 2}`,
        display: "flex",
        flexDirection: "column",
        gap: ".5rem",
      }}
    >
      <p>{label.ar}</p>
      <div style={{ display: "flex", alignItems: "center", gap: ".25rem" }}>
        <span>{props.min}</span>
        <div style={{ flex: 1 }}>
          <Slider {...props} />
        </div>
        <span>{props.max}</span>
      </div>
    </div>
  );
}

function MultiInputControl({
  onChange,
  label: outerLabel,
  name,
  value,
  controls,
} = {}) {
  const [acc, setAcc] = useState({});
  return (
    <div className={css.control}>
      <p>{outerLabel.ar}</p>
      <div style={{ display: "flex", gap: ".5rem" }}>
        {controls.map(({ operation, placeholder, label, ...props }) => (
          <Input
            key={operation + props.name}
            onChange={(e) => {
              const stringValue = e.target.value.replace(/\s/g, "");
              if (!value?.[operation] && !stringValue) return;
              const newAcc = {
                ...acc,
                [operation]: stringValue || undefined,
              };
              if (!newAcc[operation]) delete newAcc[operation];

              if (Object.keys(newAcc).length) onChange?.(name, newAcc);
              else onChange?.(name, undefined);
              setAcc(newAcc);
            }}
            placeholder={placeholder?.ar}
            {...props}
            value={
              value?.[operation] || value?.[operation.replace("e", "")] || ""
            }
          />
        ))}
      </div>
    </div>
  );
}

function InputControl({
  onChange,
  operation,
  label,
  name,
  suffix,
  value,
  ...props
} = {}) {
  return (
    <div className={css.control}>
      <p>{label.ar}</p>
      <div>
        <Input
          onChange={(e) => {
            if (!e.target.value) return onChange?.(name, undefined);
            onChange?.(name, {
              [operation]: e.target.value,
            });
          }}
          {...props}
        />
      </div>
    </div>
  );
}
const PricesLabels = {
  price: {
    ar: "السعر السنوي",
  },
  price_2_payments: {
    ar: "السعر السنوي",
  },
  price_4_payments: {
    ar: "السعر السنوي",
  },
  price_12_payments: {
    ar: "السعر الشهري",
  },
};

function PricesControl({ onChange, value: v, controls, ...props }) {
  const { filters, updateContext, listing, page, ...pathData } = usePath();
  const url = useMemo(() => generateUrl(pathData)?.split("?")[0], []);

  const router = useRouter();
  const defaultValue = [
    filters.price,
    filters.price_2_payments,
    filters.price_4_payments,
    filters.price_12_payments,
  ];
  const [name, setName] = useState(
    (defaultValue[0] && "price") ||
      (defaultValue[1] && "price_2_payments") ||
      (defaultValue[2] && "price_4_payments") ||
      (defaultValue[3] && "price_12_payments") ||
      "price",
  );

  useEffect(() => {
    const defaultValue = [
      filters.price,
      filters.price_2_payments,
      filters.price_4_payments,
      filters.price_12_payments,
    ];
    setName(
      (defaultValue[0] && "price") ||
        (defaultValue[1] && "price_2_payments") ||
        (defaultValue[2] && "price_4_payments") ||
        (defaultValue[3] && "price_12_payments"),
    );
  }, [filters]);
  return (
    <div className={css.prices}>
      <RadioControl
        value={filters?.rent_period?.eq}
        operation={"eq"}
        name="rent_period"
        label={{
          ar: "مدة عقد الإيجار",
        }}
        options={[
          {
            label: {
              ar: "سنوي",
            },
            value: "3",
            path: "/سنوي",
          },

          {
            label: {
              ar: "شهري",
            },
            value: "2",
            path: "/شهري",
          },
        ]}
        onChange={(_, period, filterAsPath) => {
          return updateContext({
            filterAsPath,
            filters: {
              ...filters,
              rent_period: period,
              price: undefined,
              price_2_payments: undefined,
              price_4_payments: undefined,
              price_12_payments: undefined,
            },
          });
        }}
      />

      {`${filters?.rent_period?.eq}` === "3" && (
        <div className={`${css.control} ${css.radio}`}>
          <p>الدفعات</p>
          <div className={css.horizontalList}>
            {props.options
              .filter((opt) => opt.value !== undefined)
              .map((opt) => (
                <AppLink
                  key={name + opt.value}
                  path={url + (opt.path || "")}
                  className={filters[opt.value] && css.active}
                  onClick={() => {
                    if (filters[opt.value])
                      return updateContext({
                        filters: {
                          ...filters,
                          price: undefined,
                          price_2_payments: undefined,
                          price_4_payments: undefined,
                          price_12_payments: undefined,
                        },
                      });
                    return updateContext({
                      filters: {
                        ...filters,
                        price: undefined,
                        price_2_payments: undefined,
                        price_4_payments: undefined,
                        price_12_payments: undefined,
                        [opt.value]: { gte: 1 },
                      },
                    });
                  }}
                >
                  {opt?.label?.ar}
                </AppLink>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export const FiltersUi = {
  radio: RadioControl,
  checkbox: CheckboxControl,
  select: SelectControl,
  slider: SliderControl,
  range: SliderControl,
  text: InputControl,
  number: InputControl,
  multiInput: MultiInputControl,
  prices: PricesControl,
};
export default FiltersUi;
